import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Check } from 'lucide-react';

export default function PaymentSuccess() {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/registries');
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 to-gray-800 flex items-center justify-center p-4">
      <div className="bg-gray-800/50 backdrop-blur-sm rounded-lg p-8 max-w-md w-full text-center">
        <div className="flex justify-center mb-6">
          <div className="bg-green-900/50 p-4 rounded-full">
            <Check className="w-12 h-12 text-green-400" />
          </div>
        </div>
        <h1 className="text-2xl font-bold text-white mb-4">Payment Successful!</h1>
        <p className="text-gray-300 mb-6">
          Thank you for your gift. The registry owner will be notified of your contribution.
        </p>
        <p className="text-sm text-gray-400">
          Redirecting you back to the registries page...
        </p>
      </div>
    </div>
  );
}